<template>
  <iModal title="添加证件" v-model="addExcelShow" class-name="vertical-center-modal" width="600px" :closable="false" :mask-closable="false" @on-cancel="cancel">
    <div class="admin-add" style="padding: 14px">
      <div class="admin-add-content">

        <Steps :current="current">
          <Step title="下载模板"></Step>
          <Step title="上传表格"></Step>
          <Step title="完成"></Step>
        </Steps>
      </div>
      <br>
      <h4>1、请按照模板格式准备要导入的数据 </h4>
      <div style="padding-left: 30px;">
        <a href="javascript:;" style="text-decoration: none;margin: 5px 0;display: inline-block;" @click="download()">下载模板
        </a>
        <p style="color: #999;margin: 5px 0;">
          注意事项：<br>
          1. 下载的模板为Excel表格,可用Office或WPS打开 <br>
          2. 请勿更改Excel格式，模板中的表头不可更改，不可删除 <br>
          3. 请确认上传的文件格式为(.xlsx)文件小于2M
        </p>
      </div><br>

      <h4>2、上传准备好的Excel文件</h4>
      <div style="padding-left: 30px;margin-top: 5px">
        <Upload :action="uploadUrl" :before-upload=" BeforeUpload" :on-success="SuccessUpload" :default-file-list="Filelist">
          <Button icon="ios-cloud-upload-outline icon" v-if="!loading">上传文件</Button>
          <Button icon="ios-cloud-upload-outline icon" v-else disabled>上传文件</Button>
        </Upload>
      </div>
    </div>
    <div slot="footer">
      <Button style="width:120px;" type="primary" disabled v-if="disabled&&!loading">开始导入</Button>
      <Button style="width:120px;" type="primary" disabled :loading="loading" v-if="!disabled&&loading">开始导入</Button>
      <Button style="width:120px;" type="primary" @click="handleSubmit('formInline',0)" v-if="!disabled&&!loading">开始导入</Button>
      <Button style="width:120px;" type="primary" @click="cancel()">取消</Button>
    </div>
  </iModal>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "add-cret-excel",
  props: {
    addExcelShow: {
      type: Boolean,
      default: false,
    },
    BadgeType: {
      type: String,
    },
  },
  data () {
    return {
      disabled: true, //是否禁用上传文件按钮
      key: "",
      current: 0,
      Filelist: [],
      loading: false,
    };
  },
  watch: {
    addExcelShow (val, oldVal) {
      if (!val) this.$emit("close");
    },
  },
  components: {},
  computed: {
    ...mapGetters({
      exhibition: "loginModule/getExhibition",
      uploadUrl: "getUploadUrl2",
      joinInfo: "loginModule/getJoinInfo",
      company: "loginModule/getCompany",
    }),
    header () {
      return this.$store.state.header;
    },
  },
  methods: {
    download () {
      require.ensure([], () => {
        const {
          export_json_to_excel,
        } = require("../../../../../assets/js/Export2Excel"); //这个地址和页面的位置相关，这个地址是Export2Excel.js相对于页面的相对位置
        const tHeader = ["姓名"]; //这个是表头名称 可以是iveiw表格中表头属性的title的数组
        const filterVal = ["name"];
        const exData1 = [{}];
        //与表格数据配合 可以是iview表格中的key的数组
        const data = this.formatJson(filterVal, exData1);

        export_json_to_excel(tHeader, data, "证件申请"); //列表excel  这个是导出表单的名称
      });
    },
    formatJson (filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    BeforeUpload (file) {
      const extension = file.name.split(".")[1] === "xls";

      const extension2 = file.name.split(".")[1] === "xlsx";

      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!extension && !extension2) {
        this.$Message.error("上传模板只能是 xls、xlsx格式!");
      }
      if (!isLt2M) {
        this.$Message.error("上传模板大小不能超过 2MB!");
      }
      if (file.length > 1) {
        this.$Message.error("只能上传单个文件");
      }
      return extension || extension2;
    },
    SuccessUpload (file, fileList) {
      this.key = file.list[0].split("key=")[1];

      this.current = 1;
      this.disabled = false;
    },
    handleSubmit () {
      this.loading = true;
      let opt = {
        JoinId: this.joinInfo.id,
        FileKey: this.key,
        CompanyName: this.company.name,
        BadgeType: this.BadgeType,
      };
      this.$http
        .post(`/api/DeExCardPlan/Import`, opt, this.header)
        .then((res) => {
          if (res.status === 200 && res.data.successed) {
            this.$Message.success(res.data.msg);
            this.loading = false;
            this.$emit("close");
            this.$parent.init();
          } else {
            this.$Message.error(res.data.msg);
            this.loading = false;
            setTimeout(() => {
              this.$emit("close");
            }, 2000);
          }
        });
    },
    cancel () {
      if (this.loading == false) {
        this.$emit("close");
      } else {
        this.$Message.error("数据正在处理，请稍后。。。");
      }
    },
  },
};
</script> 